import React, { useCallback } from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'

const MetadataTag = ({ label, onClose }) => {
  const onPreventMouseDown = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
  }, [])

  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label}
    </Tag>
  )
}

MetadataTag.propTypes = {
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default MetadataTag
